import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SendIcon from '@material-ui/icons/Send';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as paths from 'src/routes/paths';
import { TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      minWidth: '10rem',
    },
  },
  list: {
    '&:hover': {
      backgroundColor: '#CB262A',
      color: 'white',
      '& .MuiListItemIcon-root': {
        color: 'white',
      },
    },
  },
}));

const ValueMapSelectorPage = (props) => {
  const classes = useStyles();
  // const history = useHistory()
  const {
    categories = [],
    subCategories = [],
    segments = [],
    SubSgments = [],
    handleSelectCat,
    handleSelectSubCat,
    handleSelectSeg,
    handleSelectTerritorie,
    route,
    territories = [],
  } = props;

  return (
    <>
      <CardTitle title="Mapas de valor" />
      <Card>
        <CardBody>
          <h5>Seleccione una categoría</h5>
          <div className={classes.root}>
            {categories.map((button, index) => (
              <Fragment key={button.categoria}>
                <Button
                  style={{ backgroundColor: !button.selected ? '#000' : '#FFA500', color: '#fff' }}
                  variant="contained"
                  onClick={() => handleSelectCat({ ...button, index })}
                >
                  {button.categoria}
                </Button>
              </Fragment>
            ))}
            <br />
            <h5>Seleccione una sub - categoría</h5>
            {subCategories.map((button) => (
              <Fragment key={button.subcategoria}>
                <Button
                  style={{ backgroundColor: !button.selected ? '#000' : '#FFA500', color: '#fff' }}
                  variant="contained"
                  onClick={() => handleSelectSubCat(button)}
                >
                  {button.subcategoria}
                </Button>
              </Fragment>
            ))}
            <br />
            <h5>Seleccione una segmento</h5>
            {segments.map((button) => (
              <Fragment key={button.segmento}>
                <Button
                  style={{ backgroundColor: !button.selected ? '#000' : '#FFA500', color: '#fff' }}
                  variant={!button.selected ? 'contained' : 'outlined'}
                  onClick={() => handleSelectSeg(button)}
                >
                  {button.segmento}
                </Button>
              </Fragment>
            ))}
            {SubSgments.length > 0 && (
              <>
                <h5>Seleccione un territorio</h5>
                <Autocomplete
                  id="combo-box-demo"
                  freeSolo
                  options={territories}
                  getOptionLabel={(option) => option.territorio}
                  onChange={(event, newValue) => {
                    handleSelectTerritorie(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="Unidades de Negocio" variant="outlined" />}
                />
              </>
            )}
            {route.territorio ? (
              <>
                <List
                  dense
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                  subheader={(
                    <ListSubheader component="div" id="nested-list-subheader">
                      Seleccione un - sub segmento y/o mapa de valor
                    </ListSubheader>
                  )}
                >
                  {SubSgments.map((value) => (
                    <ListItem
                      key={value.id}
                      className={classes.list}
                      component={Link}
                      to={{
                        pathname: paths.MAP_VALUE_DETAIL,
                        state: {
                          subSegment: value.subsegmento,
                          segment: route.seg,
                          subCategory: route.subCat,
                          category: route.cat,
                          id: route?.id || '',
                          territorio: route?.territorio || '',
                          unidad_negocio_id: route?.unidad_negocio_id || '',
                        },
                      }}
                    >
                      <ListItemIcon>
                        <SendIcon style={{ color: '#FFA500' }} />
                      </ListItemIcon>
                      <ListItemText primary={value.subsegmento} />
                    </ListItem>
                  ))}
                </List>
              </>
            ) : null}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default ValueMapSelectorPage;
